import isEmpty from 'lodash.isempty';
import { EVENT_TYPES, MARK_TYPE } from '../../constants/shared/ProbeDetailsConstants';
import {
    SUBSTITUTE as SUBSTITUTE_INPUT_TYPE,
    INSERT_RIGHT,
} from '../../constants/shared/ToolbarConstants';

const { USER_EVENT } = EVENT_TYPES;
const { INSERT, SUBSTITUTE, OMIT, CORRECT } = MARK_TYPE;

export const inputEventHandler = (content, wordPosition, inputType, setWordEvent) => {
    if (!isEmpty(content)) {
        const eventType = inputType === SUBSTITUTE_INPUT_TYPE ? SUBSTITUTE : INSERT;
        const position = inputType === INSERT_RIGHT ? wordPosition + 1 : wordPosition;

        setWordEvent({
            eventType,
            eventDetails: {
                annotationContent: content,
                annotationType: 'text',
                source: USER_EVENT,
                position,
            },
        });
    }
};

export const omitHandler = (wordPosition, setWordEvent) => {
    setWordEvent({
        eventType: OMIT,
        eventDetails: {
            startPosition: wordPosition,
            endPosition: wordPosition,
            source: USER_EVENT,
        },
    });
};

export const correctHandler = (wordPosition, isInsertCorrection, setWordEvent) => {
    setWordEvent({
        eventType: CORRECT,
        eventDetails: {
            endIsInsert: isInsertCorrection,
            endPosition: wordPosition,
            source: USER_EVENT,
            startIsInsert: isInsertCorrection,
            startPosition: wordPosition,
        },
    });
};
